<template>
  <div>
    <el-dialog title="设置赠送优惠券" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form size="small" :model="form">
            <el-form-item label="开启赠送优惠券:" :rules="[{ required: true, message: '请选择' }]" >
              <el-radio-group v-model="is_open_send_coupon">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="选择优惠券 " prop="">
              <el-button @click="openConpon" icon="el-icon-plus">选择优惠券</el-button>
              <p>注： 会员领取的优惠券已达到限制数量，将不再赠送给该会员。</p>
            </el-form-item>
            <el-form-item v-if="send_coupon_data.length>0">
              <el-col :span="4">
                优惠券名称
              </el-col>
              <el-col :span="4">
                状态
              </el-col>
              <el-col :span="4">
                赠送数量
              </el-col>
              <el-col :span="4" style="text-align: center;">
                操作
              </el-col>
            </el-form-item>
            <el-form-item label=""  v-for="(item,index) in send_coupon_data"  :key="index" v-if="send_coupon_data.length>0">
                <el-col :span="4">
                      {{item.name}}
                </el-col>
                <el-col :span="4" >
                  <el-switch v-model="item.status" active-color="#13ce66" inactive-color="#ff4949" style="width:50px">
                  </el-switch>
                </el-col>
                <el-col :span="4">
                    <el-input v-model="item.number"  placeholder="赠送数量"  autocomplete="off"></el-input>
                </el-col>
                <el-col :span="4" style="text-align: center;">
                  <el-button @click.prevent="removeCoupon(index)">删除</el-button>
                </el-col>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editCoupon" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
    <!--选择优惠券-->
    <GetCoupon v-if="open_coupon" :open_add="open_coupon" :islist="islist" :excludeIds="excludeIds" @closeDialog="closeCouponFunc($event, 'add')"></GetCoupon>
  </div>

</template>

<script>
    import SkucouponApi from '@/api/skucoupon.js';
    import GetCoupon from '@/components/coupon/GetCoupon.vue';
    import {mergeTable} from '@/utils/table.js';
    export default {
        components: {
          GetCoupon
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                open_coupon: false,
                islist: true,
                is_open_send_coupon: 0,
                excludeIds: [],
                send_coupon_data: [],
            };
        },
        props: ['is_open_setcoupon','form'],
        created() {
            if(this.form.is_open_send_coupon==true){
              this.is_open_send_coupon = 1;
            } else {
              this.is_open_send_coupon = 0;
            }
            if(this.form.send_coupon_data.length>0){
              this.excludeIds = this.form.coupon_ids;
              this.send_coupon_data = this.form.send_coupon_data;
            }
            this.dialogVisible = this.is_open_setcoupon;
        },
        methods: {
            /*选择优惠券*/
            openConpon() {
              this.open_coupon = true;
            },

            /*关闭优惠券*/
            closeCouponFunc(e) {
              this.open_coupon = false;
              console.log(e)
              if (e.type != 'error') {
                let arr = [];
                let coupon_ids = [];
                for (let i = 0; i < e.params.length; i++) {
                  let item = e.params[i];
                  let obj = {
                    name: item.name,
                    coupon_id: item.coupon_id,
                    number: 1,
                    status: true,
                  };
                  arr.push(obj);
                  coupon_ids.push(item.coupon_id);
                }
                this.excludeIds = this.excludeIds.concat(coupon_ids);
                this.send_coupon_data = this.send_coupon_data.concat(arr);
                this.send_coupon_data = mergeTable(this.send_coupon_data);
                console.log("this.send_coupon_data",this.send_coupon_data);
              }
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            },
            removeCoupon(index){
                if (index !== -1) {
                    this.send_coupon_data.splice(index, 1);
                }
            },
            editCoupon(){
                let self =this;
                let params = {};
                params.product_sku_id = self.form.product_sku_id;
                params.is_open_send_coupon = self.is_open_send_coupon;
                params.send_coupon_data = JSON.stringify(self.send_coupon_data);
                SkucouponApi.editSku(params, true)
                .then(data => {
                    self.loading = false;
                    self.dialogFormVisible(1);
                })
                .catch(error => {
                self.loading = false;
                });

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/plus/skucoupon/sku/part/SetCoupon.vue